"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeSnippet;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _CodeSnippetBlock = _interopRequireDefault(require("./CodeSnippetBlock"));

var _excluded = ["className", "blocks"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CodeSnippet(_ref) {
  var className = _ref.className,
      blocks = _ref.blocks,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("p-code-snippet", {
      "is-bordered": blocks.some(function (block) {
        return block.content;
      })
    }, className)
  }, props), blocks.map(function (blockProps, i) {
    return /*#__PURE__*/_react.default.createElement(_CodeSnippetBlock.default, _extends({
      key: "code-snippet-block-".concat(i)
    }, blockProps));
  }));
}